/**
 * Task status constants
 */
export const TASK_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};

/**
 * TaskData class for handling task objects
 */
export class TaskData {
  static STATUS = TASK_STATUS;

  constructor(data) {
    this.task_id = data.task_id;
    this.machine_id = data.machine_id;
    this.profile_id = data.profile_id;
    this.command = data.command || 'launch_dcc';
    this.parameters = data.parameters || {};
    this.status = data.status || TASK_STATUS.QUEUED;
    this.result = data.result || null;
    this.error_message = data.error_message || null;
    this.requested_by = data.requested_by || null;
    this.queued_at = data.queued_at;
    this.started_at = data.started_at;
    this.completed_at = data.completed_at;
    this.machine_hostname = data.machine_hostname || null;
    this.profile_name = data.profile_name || null;
  }

  get isQueued() {
    return this.status === TASK_STATUS.QUEUED;
  }

  get isRunning() {
    return this.status === TASK_STATUS.RUNNING;
  }

  get isCompleted() {
    return this.status === TASK_STATUS.COMPLETED;
  }

  get isFailed() {
    return this.status === TASK_STATUS.FAILED;
  }

  get isPending() {
    return this.isQueued || this.isRunning;
  }

  static fromApiResponse(data) {
    return new TaskData(data);
  }
}

/**
 * Launch request data structure
 */
export class LaunchRequest {
  constructor({
    launcher_name,
    profile_name = null,
    machine_hostname = null,
    scene_file = null,
    additional_args = null,
    environment_overrides = null,
    requested_by = null
  }) {
    this.launcher_name = launcher_name;
    this.profile_name = profile_name;
    this.machine_hostname = machine_hostname;
    this.scene_file = scene_file;
    this.additional_args = additional_args;
    this.environment_overrides = environment_overrides;
    this.requested_by = requested_by;
  }

  toApiPayload() {
    const payload = {
      launcher_name: this.launcher_name
    };
    
    // Only include non-null fields
    if (this.profile_name) payload.profile_name = this.profile_name;
    if (this.machine_hostname) payload.machine_hostname = this.machine_hostname;
    if (this.scene_file) payload.scene_file = this.scene_file;
    if (this.additional_args?.length) payload.additional_args = this.additional_args;
    if (this.environment_overrides && Object.keys(this.environment_overrides).length) {
      payload.environment_overrides = this.environment_overrides;
    }
    if (this.requested_by) payload.requested_by = this.requested_by;
    
    return payload;
  }
}

/**
 * Launch response data structure
 */
export class LaunchResponse {
  constructor(data) {
    this.task_id = data.task_id;
    this.machine_hostname = data.machine_hostname;
    this.profile_name = data.profile_name;
    this.status = data.status;
    this.message = data.message;
  }

  static fromApiResponse(data) {
    return new LaunchResponse(data);
  }
}

